"use client";

import { c as _c } from "react/compiler-runtime";
import { useAction } from "next-safe-action/hooks";
import { useState } from "react";
import { subscriberSaveAction } from "@/actions/subscriber";
import { Input } from "@/components/ui/input";
import { useTranslations } from "@/i18n/client";
import { PendingButton } from "@/ui/admin/pending-button";
export const NewsletterClient = props => {
  const $ = _c(30);
  const {
    domain
  } = props;
  const [email, setEmail] = useState("");
  const {
    execute,
    isPending,
    result
  } = useAction(subscriberSaveAction);
  const t = useTranslations("/newsletter");
  let t0;
  if ($[0] !== domain || $[1] !== email || $[2] !== execute) {
    t0 = e => {
      e.preventDefault();
      execute({
        email,
        domain,
        name: ""
      });
    };
    $[0] = domain;
    $[1] = email;
    $[2] = execute;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== t) {
    t1 = t("emailPlaceholder");
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_0 => setEmail(e_0.target.value);
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== email || $[8] !== isPending || $[9] !== t1) {
    t3 = <div className="flex-1 sm:max-w-md "><Input type="email" placeholder={t1} className="w-full h-12 px-4 border-gray-200 focus:ring-2 focus:ring-blue-500 bg-white" value={email} onChange={t2} required={true} disabled={isPending} /></div>;
    $[7] = email;
    $[8] = isPending;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t) {
    t4 = t("subscribe");
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isPending || $[14] !== t4) {
    t5 = <PendingButton pending={isPending} type="submit" className="h-12 inline-flex items-center justify-center rounded-full px-6 font-medium transition-colors focus:outline-hidden focus:ring-1 focus:ring-(--theme-button-color) bg-[var(--theme-hero-section-cta-background-color,#222)] text-[var(--theme-hero-section-cta-color,#EEE)] hover:bg-[var(--theme-hero-section-cta-hover-background-color,#555)]">{t4}</PendingButton>;
    $[13] = isPending;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== result.data || $[17] !== result.serverError || $[18] !== result.validationErrors?.email?._errors?.[0] || $[19] !== t) {
    t6 = (result.data ? t("emailAdded") : result.serverError ? result.serverError : result.validationErrors?.email?._errors?.[0]) || "\xA0";
    $[16] = result.data;
    $[17] = result.serverError;
    $[18] = result.validationErrors?.email?._errors?.[0];
    $[19] = t;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t6) {
    t7 = <p className="text-sm text-muted-foreground flex-1 basis-full">{t6}</p>;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t3 || $[24] !== t5 || $[25] !== t7) {
    t8 = <div className="flex w-full flex-col gap-2 sm:flex-row sm:flex-wrap">{t3}{t5}{t7}</div>;
    $[23] = t3;
    $[24] = t5;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t0 || $[28] !== t8) {
    t9 = <form onSubmit={t0} className="flex w-full flex-col gap-2">{t8}</form>;
    $[27] = t0;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
};